import { AUTH_DISABLED } from "@/authConfig"

type TokenGetter = () => string | undefined

let accessTokenGetter: TokenGetter | null = null

export function setAccessTokenGetter(getter: TokenGetter): void {
  accessTokenGetter = getter
}

export function getAccessToken(): string | undefined {
  if (AUTH_DISABLED) {
    return undefined
  }
  return accessTokenGetter?.()
}
